import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.css']
})

export class OurTeamComponent implements OnInit {

  array:any=[]
  array2:any=[]
  arrayGetNameSection: any
  arrayResearchTopicCategroy:any
  arrayTeamCategory:any =[]
  arrayTeamMember:any=[]
  selectedItem: any
  id: any
  load: boolean = false
  constructor(private home: HomeService, private _Activatedroute: ActivatedRoute) {
    this._Activatedroute.paramMap.subscribe(params => {
      window.scroll(0, 0);
      this.getAll()
    });
  }

  ngOnInit(): void {


  }


  getAll()
  {

    this.array = []
    this.array2=[]
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    if (this.id == null || this.id == '') {
      this.selectedItem = null
      this.home.getPost('getPost','', 'en', '', 'TeamCategory', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayTeamCategory = data

        console.log('aa',data)
        let arr = data as []
        this.home.getPost('getPost', '', 'en', '', 'TeamMember', '', '', '-1').subscribe(data => {
          this.arrayTeamMember = data

          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postImage:el2['postImage'],team_Linkedin:el2['team_Linkedin'],team_GoogleSchoolar:el2['team_GoogleSchoolar'],team_Publons:el2['team_Publons'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourTeams:this.array
               }
           )

               this.array = []
          })
          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
    else
    this.home.getPost('getPost','', 'en', '', 'TeamCategory', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayTeamCategory = data

      let arr = data as []

    this.home.getPost('getPost', '', 'en', '', 'TeamMember', this.id, '', '-1').subscribe(data => {
          this.selectedItem = this.id
          this.arrayTeamMember = data


          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postImage:el2['postImage'],team_Linkedin:el2['team_Linkedin'],team_GoogleSchoolar:el2['team_GoogleSchoolar'],team_Publons:el2['team_Publons'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourTeams:this.array
               }
           )

               this.array = []
          })


          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
      console.log(this.array2)

    }
  getTeam(sectionId: string) {
    this.load = false

    this.selectedItem = sectionId

    this.home.getPost('getPost', '', 'en', '', 'TeamMember', "NTROOT0", '', '-1').subscribe(data => {
      this.arrayTeamMember = data
      console.log("arrayTeamMember",this.arrayTeamMember);
      
        this.load = true
    })
  }

  // listClick(event: any, newValue: any) {
  //   this.selectedItem = newValue;
  // }

  // getAllTeam(event: any, newValue: any) {
  //   this.load = false
  //   this.selectedItem = newValue;
  //   this.home.getPost('getPost', '', 'en', '', 'TeamMember','', '', '-1').subscribe(data => {
  //     this.arrayTeamMember = data
  //     this.load = true
  //   })
 // }

}
